export default {
	'en': {
		'classLabel': 'Class',
		'rank': 'Rank',
		'question': 'Game Points',
		'currencyBalance': 'Balance (Excluding Game Points)',
		'totalPoints': 'Total Points',
		'rankChange': 'Rank Change',
	},
	'tc': {
		'classLabel': '班別',
		'rank': '排名',
		'question': '遊戲積分',
		'currencyBalance': '餘額（不計算遊戲積分）',
		'totalPoints': '總積分',
		'rankChange': '排名變化',
	}
}